<template>
  <county-map v-if="counties && coverage" :counties="colored" :view-box='counties.viewBox' :transform='counties.transform' v-once>
  </county-map>
</template>

<script>
import CountyMap from '@/components/maps/county-map'

export default {
  name: 'county-coverage-map',
  props: ['appCode'],
  components: { CountyMap },
  data () {
    return {
      counties: null,
      coverage: null
    }
  },
  created () {
    this.loadLocale(this.$store.state.locale.current)
    this.loadAppCode(this.appCode)
  },
  watch: {
    '$store.state.locale.current' (locale) {
      this.loadLocale(locale)
    },
    appCode (code) {
      this.loadAppCode(code)
    }
  },
  computed: {
    dataStartFieldName () {
      const localeMapping = {
        'STATE-IN': {
          COURT: 'dataStart',
          JUDGMENT: 'dataStart',
          RECORDER: 'indexDataStart',
          TW: 'dataStart'
        },
        'STATE-MI': {
          REGISTER: 'indexDataStart'
        }
      }[this.$store.state.locale.current] || {}
      return localeMapping[this.appCode.toUpperCase()] || 'dataStart'
    },
    colored () {
      if (!this.counties || !this.coverage) return []

      const now = new Date()
      return this.counties.list
        .map((county) => {
          const coverage = this.coverage.find(c => c.id === county.id)
          return {
            ...county,
            dataStart: coverage ? coverage[this.dataStartFieldName] || '' : ''
          }
        })
        .map((county) => {
          const start = new Date(county.dataStart.split(' ').join(' 1 '))
          const yearDiff = (now.getFullYear() - start.getFullYear()) - (start.getMonth() > now.getMonth() ? 1 : 0)
          const color = isNaN(start) ? 'white'
            : yearDiff >= 20 ? '#009800'
              : yearDiff >= 10 ? '#00cb00'
                : '#66fe66'
          return {
            id: county.id,
            name: county.name,
            paths: county.paths,
            fill: color
          }
        })
    }
  },
  methods: {
    loadLocale (locale) {
      if (locale === 'STATE-IN') {
        import('@/assets/maps/indiana-counties'
        /* webpackChunkName: "maps-indiana-counties" */)
          .then(json => { this.counties = json })
      }
      if (locale === 'STATE-MI') {
        import('@/assets/maps/michigan-counties'
        /* webpackChunkName: "maps-michigan-counties" */)
          .then(json => { this.counties = json })
      }
    },
    loadAppCode (code) {
      if (!code) return
      switch (code.toUpperCase()) {
        case 'COURT':
          import('@/assets/maps/indiana-court-coverage'
          /* webpackChunkName: "maps-indiana-court-coverage" */)
            .then(json => { this.coverage = this.readCoverage(json) })
          break
        case 'RECORDER':
          import('@/assets/maps/indiana-recorder-coverage'
          /* webpackChunkName: "maps-indiana-recorder-coverage" */)
            .then(json => { this.coverage = this.readCoverage(json) })
          break
        case 'TW':
          import('@/assets/maps/indiana-tax-warrant-coverage'
          /* webpackChunkName: "maps-indiana-tax-warrant-coverage" */)
            .then(json => { this.coverage = this.readCoverage(json) })
          break
        case 'REGISTER':
          import('@/assets/maps/michigan-recorder-coverage'
          /* webpackChunkName: "maps-michigan-recorder-coverage" */)
            .then(json => { this.coverage = this.readCoverage(json) })
          break
        case 'JUDGMENT':
          import('@/assets/maps/indiana-judgment-coverage'
          /* webpackChunkName: "maps-indiana-judgment-coverage" */)
            .then(json => { this.coverage = this.readCoverage(json) })
          break
      }
    },
    /* converts an index keyed object to an array */
    readCoverage (json) {
      let arr = []
      for (var key in json) {
        arr.push(json[key])
      }
      return arr
    }
  }
}
</script>
